import { t } from '@lingui/core/macro';
import { CommonMetadataAllowedValuesFilter } from './MetadataAllowedValuesFilter';
export const currencyFilterLabel = () => t({ message: 'Currency', comment: 'Insights filter: Currency' });
export function CurrencyFilter() {
    return (<CommonMetadataAllowedValuesFilter name="Currency" field="metadataDocumentCurrency" label={currencyFilterLabel()}/>);
}
